// src/pages/SalesLedger/SalesLedgerThunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAccountByTypeApi } from "../../apiservice/setting";
import { getSalesLedgerApi } from "../../apiservice/reports";

export const fetchSaleAccounts = createAsyncThunk(
  "salesLedger/fetchSaleAccounts",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "sale_account" });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchSalesLedger = createAsyncThunk(
  "salesLedger/fetchSalesLedger",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        accId: filters?.accId || null,
        dateFrom: filters?.fromDate || null,
        dateTo: filters?.toDate || null,
      };
      const res = await getSalesLedgerApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
